exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\n.login-page{\n    background: url(" + require("./assets/img/banner.jpg") + ") no-repeat !important;\n    background-size: 100% !important;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// D:/01.Developer/0.Web/Bravo8-Base/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!D:/01.Developer/0.Web/Bravo8-Base/node_modules/postcss-loader?{"ident":"postcss"}!D:/01.Developer/0.Web/Bravo8-Base/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/styles.css
// module chunks = styles